export default "__VITE_ASSET__84407553__"